<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="edit-person-portal-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Update Portal
                        </h4>
                    </div>

                    <div class="modal-body">
                        <text-form-group
                                v-model="externalId"
                                name="external_id"
                                label="External ID"
                                :error="getError('external_id')"
                        ></text-form-group>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import moment from 'moment'
    import notify from '@/notify'
    import Errors from '@/mixins/Errors'
    import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

    export default {
        components: {TextFormGroup},

        mixins: [Errors],

        props: ['person', 'portal'],

        data() {
            return {
                externalId: null
            }
        },

        mounted() {
            this.listenForClose()
        },

        watch: {
            portal(value) {
                this.externalId = value.pivot.external_id
            }
        },

        methods: {
            listenForClose() {
                $(this.$el).on('hidden.bs.modal', this.reset)
            },

            submit() {
                http.put('/api/v1/people/' + this.person.data.id + '/portals/' + this.portal.id, {
                    external_id: this.externalId
                })
                    .then(response => {
                        notify.success('The portal was updated')

                        this.$emit('updated', response.data)

                        $(this.$el).modal('hide')
                    })
                    .catch(this.catchValidationErrors)
            },

            reset() {
                this.errors = {}

                this.externalId = null
            }
        }
    }
</script>
